import styled from 'styled-components';

export const StepWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x5};
`;

export const Body = styled.div`
  position: relative;
`;

export const WithSidebar = styled.div`
  /* background-color: #aaa; */
`;
